module.exports = [{"key":"fr","value":"fr","flag":"fr","text":"Français"},{"key":"en-gb","value":"en-gb","flag":"gb","text":"English"}]


//////////////////
// WEBPACK FOOTER
// ./src/countries.json
// module id = 1441
// module chunks = 0